// Cookies
function createCookie(cookieName,cookieValue,daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime()+(daysToExpire*24*60*60*1000));
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
}

function accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(';');
    for(var i=0; i<allCookieArray.length; i++) {
        var temp = allCookieArray[i].trim();
        if (temp.indexOf(name)==0)
        return temp.substring(name.length,temp.length);
    }
    return "";
}

function setCookieCloseBox(cookieName) {
    createCookie(cookieNaam, 'closed', days); // create cookie 
    document.body.removeEventListener("mouseleave", userLeave); // prevent box from reappearing
    document.body.classList.remove('newsletterbox-active'); // hide newsletter box
}

// Newsletter
function newsletterPopup() {
    var newsletterBox = document.getElementById("newsletterbox");
    if (newsletterBox) {
        var cookieNaam = "newspopup";
        var isCookie = accessCookie(cookieNaam);

        var days = newsletterBox.dataset.expire; // Get days from data-expire
        var cdown = newsletterBox.dataset.cdown; // Get count down from data-cdown
        var tnx = newsletterBox.dataset.thanks; // Get thanks from data-tnx
        var err = newsletterBox.dataset.err; // Get error from data-err
        var mail = newsletterBox.dataset.mail; // Get mail from data-mail

        if (days === undefined) { var days = 7; }
        if (cdown === undefined) { var cdown = 30000; }
        if (tnx === undefined) { var tnx = "Thanks for signing up!"; }
        if (err === undefined) { var err = "There was an error in submitting the form."; }
        if (mail === undefined) { var mail = "Please fill in your email address."; }

        // Countdown: show after X sec
        function countDownr(event) {
            setTimeout(function() {
                document.body.classList.add('newsletter-active'); // show newsletter box
            }, cdown);
        }

        // Check if user tries to leave from top
        function userLeave(event) {
            if(event.clientY <= 0) {
                document.body.classList.add('newsletter-active'); // show newsletter box
            }
        }

        // If cookie is not set show newsletter box
        if(isCookie !== 'closed') {
            countDownr(); // start countdown
        }

        // If is challenge page
        var challengeUrl = window.location.origin +'/challenge#contact_form';
        var currentUrl = window.location;
        if(currentUrl == challengeUrl) {
            document.getElementById('newsletterbox').style.display = 'none';
        }

        // Set cookie for "X" days and close newsletter box
        function setCookieNclose() {
            createCookie(cookieNaam, 'closed', days); // create cookie 
            document.body.removeEventListener("mouseleave", userLeave); // prevent box from reappearing
            document.body.classList.remove('newsletter-active'); // hide newsletter box
        }

        // On click Set cookie for "X" days and close newsletter box
        document.getElementById('closenewsletter').addEventListener("click", function() {
            setCookieNclose();
        });

        // Newsletter submit thru AJAX
        // TODO: convert in Vanilla JS
        $('form.contact-form').submit( function(){
            $('p.msg.is-green, p.msg.is-red').remove();
            if($(this).find('input[type="email"]').val() !== '') {
                var data = $(this).serialize();
                $.ajax({
                    type: "POST",
                    url: "/contact#contact_form",
                    data: data,
                    crossDomain: true,
                    success: function(response, textStatus, xhr) {
                        $('.contact-form').append('<p class="msg is-green">'+tnx+'</p>');
                        setTimeout(function(){ 
                            setCookieNclose(); 
                        }, 3000);
                    }, error: function(XMLHttpRequest, textStatus, errorThrown) {
                        $('.contact-form').append('<p class="msg is-red">'+err+'</p>');
                    }
                });

                // If customer is challenged
                if(response.status == 429) {
                    var challengeUrl = window.location.origin +'/challenge#'
                    window.location = challengeUrl
                }
            } else {
                $(this).append('<p class="msg is-red">'+mail+'</p>');
            }
            return false;
        });

        // When customer is back from challenge
        var checkURL = ["?customer_posted=true", "?contact%5Btags%5D=newsletter&form_type=customer"];
        for (var i = 0; i < checkURL.length; i++) {
            if(window.location.href.indexOf(checkURL[i]) > -1) {
                // Show newsletter box
                document.body.classList.add('newsletter-active');
                setTimeout(function(){
                    setCookieNclose(); 
                }, 5000);
            }
        }
    }
}
// Toggle Body Class
    let toggleBodyClass = function(arg) {
        document.body.classList.toggle(arg);
    }
// Get Element Height
function getElementHeight(targetElement,appendTo,cssVar) {
    let element = document.querySelector(targetElement);

    if (element) {
        let elementHeight = element.offsetHeight;
        document.querySelector(appendTo).style.setProperty(cssVar, `${elementHeight}px`);
    }
}

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
function getSetVh() {
    let vh = window.innerHeight * 0.01;
    document.body.style.setProperty('--vh', `${vh}px`);
}

window.addEventListener('resize', () => {
    getSetVh();
});

// Toggle
    let toggleClass = function(qSelectors, bodyClass) {   
        let elArray = document.querySelectorAll(qSelectors);
        elArray.forEach(function(e) {
            e.addEventListener("click", function() {
                toggleBodyClass(bodyClass);
            });
        });
    }
// Menu
    let toggleMenu = function() { 
        toggleClass('.fire-menu, .shrink-menu', 'open-menu');
    }
// Menu
    let toggleSearch = function() { 
        toggleClass('.fire-search, .shrink-search', 'open-search');
    }
// Cart
    let toggleCart = function() {
        toggleClass('.carto, .cartc', 'open-cart');

        const clsbtn = document.querySelector('.cartc');
        clsbtn.addEventListener('click', () => {
            document.body.classList.remove('hideheader');
        });
    }

// Dropdown menu header
function dropdownMenu() {
    const detailsElements = document.querySelectorAll("details.lv1");

    function handleClickOnDetails() {
      // close all details
      let detailsOpened = document.querySelectorAll("details[open].lv1");

      for (const item of detailsOpened) {
        if (this != item) {
          item.removeAttribute("open");
        }
      }
    }

    detailsElements.forEach(function (item) {
      item.addEventListener("click", handleClickOnDetails);
    });
}

// Close <details> when you click outside
var details = [...document.querySelectorAll('details')];
document.addEventListener('click', function(e) { 
    if (!details.some(f => f.contains(e.target))) { 
        details.forEach(f => f.removeAttribute('open')) 
    } else { 
        details.forEach(f => !f.contains(e.target) ? f.removeAttribute('open') : '') 
    } 
});

// update button price on variant change 
function updatePrice(obj,idd) {
    var uid = obj.options[obj.selectedIndex].getAttribute('data-price');
    var pb = document.querySelector('.uprice'+idd);
    pb.innerHTML = uid;
}

function selectOptions(obj,idd) { updatePrice(obj,idd) }

// AJAX cart.js
// AJAX cart init can be located in theme.liquid
function ajaxCart(obj) {
    // Show loading feedback
    obj.classList.add('loading');

    // on cart request success
    $(document).ajaxSuccess(function(event, jqxhr, settings) {
        if (settings.url == '/cart/add.js' || settings.url == '/cart/change.js') {
            // on cart request complete (just in case)
            $(document).on('cart.requestComplete', function(event, cart) {
                // Update # of items in cart
                document.getElementById('counter').setAttribute('data-count', cart.item_count);
                // Open cart
                document.body.classList.add('open-cart');
                document.body.classList.add('hideheader');
                // Remove loading feedback
                obj.classList.remove('loading');
            });
        }
    });

    // on cart request error
    $(document).ajaxError(function(event, jqxhr, settings) {
        if (settings.url == '/cart/add.js' || settings.url == '/cart/change.js') {
            obj.classList.remove('loading'); // Remove loading feedback
            console.log(jqxhr.responseJSON);
            alert(jqxhr.responseJSON.description);
            event.stopImmediatePropagation();
        }
    });
}

// Update # of items in cart
$(document).on('cart.requestComplete', function(event, cart) {
    document.getElementById('counter').setAttribute('data-count', cart.item_count);
});

/*** init app */
function app() {
    getSetVh(); // get Viewport Height
    dropdownMenu(); // Dropdown menu
    newsletterPopup(); // Newsletter popup
    toggleMenu(); // toggle Menu
    toggleSearch(); // toggle Search
    toggleCart(); // toggle Cart
}

/*** on DOM ready **/
document.addEventListener("DOMContentLoaded", () => { app() })


var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

$(document).ready(function() {
  if($('.cart-page').length){
    $('.cartCounter').css('display','none');
  }
});